// extracted by mini-css-extract-plugin
module.exports = {"videos":"video_list_videos__1Ate-"};